module.exports = __webpack_public_path__ + "img/hatchet-bronze.0e31eefd.svg";